import React, { useContext } from "react";
import AppContext from "../../Context/AppContext";
import { sendCommand } from "../../../util/util";
import { Text, Button, Container, Logo, RowContainer } from "../style";
import vote from "../../../static/vote.svg";
import ChatArea from "../../ChatArea";

const Vote = () => {
  const { members, websocket } = useContext(AppContext);

  return (
    <Container>
      <RowContainer>
        <Logo src={vote} alt="logo" />
        <Text>Vote who the WereWolf is!</Text>
        {members.map((member) => (
          <Button
            key={member}
            onClick={() => sendCommand(websocket, "vote", member)}
          >
            {member}
          </Button>
        ))}
      </RowContainer>
      <ChatArea />
    </Container>
  );
};

export default Vote;
